import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMilestone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.75 1C12.1642 1 12.5 1.33579 12.5 1.75V3.99999L19.032 4C19.4517 4 19.8575 4.15084 20.1752 4.42503L23.3624 7.17503C24.1715 7.87309 24.1715 9.12691 23.3624 9.82498L20.1752 12.575C19.8575 12.8492 19.4517 13 19.032 13L12.5 13V22.25C12.5 22.6642 12.1642 23 11.75 23C11.3358 23 11 22.6642 11 22.25V13L3.74999 12.9999C2.7835 12.9999 2 12.2164 2 11.2499V5.74998C2 4.78348 2.7835 3.99998 3.75 3.99998L11 3.99999V1.75C11 1.33579 11.3358 1 11.75 1ZM11.75 5.5L11.754 5.49999L19.032 5.5C19.092 5.5 19.1499 5.52155 19.1953 5.56072L22.3825 8.31072C22.4981 8.41044 22.4981 8.58956 22.3825 8.68928L19.1953 11.4393C19.1499 11.4785 19.092 11.5 19.032 11.5L3.75 11.4999C3.61193 11.4999 3.5 11.388 3.5 11.2499L3.5 5.74998C3.5 5.61191 3.61193 5.49998 3.75 5.49998L11.746 5.49999L11.75 5.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgMilestone;
